
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { AuthService } from './auth.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  canLoad(route: Route): boolean {
    const user = this.authService.getCurrentUser();
    if (user && user.token) {

      if (user.is_token_expired) {
        this.router.navigate(['/authentication/locked']);
        return false;

      } else if (this.isProcurementOnlyUser(user) && route?.path !== 'launchpad') {
        this.router.navigate(['/launchpad'], { replaceUrl: true });
        return false;

      } else {
        return true;
      }

    } else {
      const path = route?.path ? `/${route.path}` : '/';
      this.router.navigate(['/authentication/signin'], { queryParams: { returnUrl: path } });
      return false;
    }
  }

  constructor(private router: Router, private authService: AuthService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.authService.getCurrentUser();
    if (user && user.token) {

      if (user.is_token_expired) {
        this.router.navigate(['/authentication/locked']);
        return false;

      } else if (this.isProcurementOnlyUser(user) && !this.isLaunchpadRoute(state?.url)) {
        this.router.navigate(['/launchpad'], { replaceUrl: true });
        return false;

      } else {
        return true;
      }

    } else {
      this.router.navigate(['/authentication/signin'], { queryParams: { returnUrl: state?.url || '/' } });
      return false;
    }

  }

  private isProcurementOnlyUser(user: any): boolean {
    const roleTypes = Array.isArray(user?.roleTypes) ? user.roleTypes : [];
    const normalizedRoleTypes = roleTypes
      .map((roleType: unknown) => String(roleType || '').trim().toLowerCase())
      .filter(Boolean);

    return normalizedRoleTypes.includes('procurement') && !normalizedRoleTypes.includes('forlab');
  }

  private isLaunchpadRoute(url?: string): boolean {
    const path = String(url || '').split('?')[0].split('#')[0];
    return path === '/launchpad' || path.startsWith('/launchpad/');
  }
}
